module.exports = __webpack_public_path__ + "img/right.24bcfca5.png";